export const API_TYPES = {
  AUTH: "auth",
  CITAJTEO: "citajteo",
};

export const API_APP_NAMES = {
  CITAJTEO: "express_citajteo",
};
